<!-- Copyright 2022, Common Good Learning Tools LLC -->
<template><div>
	<div class="k-frameworks-map-outer" @mousemove="mouse_moved">
		<div class="k-frameworks-map-instructions"><i>Click an issuing agency to view frameworks</i></div>
		<div v-for="(row, index) in squares" :key="index" class="k-frameworks-map-row" :class="row_css(index)">
			<div v-for="(square, index) in row" :key="index" class="k-frameworks-map-sq" :style="square_style"><k-hover v-slot:default="{hover}" open-delay="150"><div class="k-frameworks-map-sq-mid">
				<div :class="square_css(square,hover)" @click.stop="square_clicked($event,square)">
					<div>{{square_label(square)}}</div>
					<k-spacer/>
					<div v-if="square&&square.category">
						<div v-if="true" class="k-frameworks-map-sq-subs"><span v-for="(subject_record, index) in square.subject_records" :key="index" v-show="subject_record.doc_showing" class="k-frameworks-map-sq-sub" :class="'k-framework-color-'+subject_record.subject.color_class+'-text-light'">•</span></div>
					</div>
				</div>
				<div v-show="hovered_square_category_showing(square)" v-visible="!hover_changed" class="k-frameworks-map-square-menu elevation-3" :style="category_menu_style" :class="square.category?'':'k-frameworks-map-square-menu-no-category'" :data-map-label="square.map_label_for_element">
					<div v-if="!square.category">{{square.map_label_display}}: No frameworks hosted (yet!) on {{site_config.app_name}}.</div>
					<div v-else>
						<!-- <div v-else @click.stop="expanded_square=square"> -->
						<div class="k-frameworks-map-square-menu-title">
							<div>{{square.category.title}}</div>
							<k-spacer/>
							<nobr v-if="square.category.framework_records.length>0" style="font-weight:normal; font-size:14px; margin:0 0 -2px 4px;">({{ square.category.framework_records.length + U.ps(' framework', square.category.framework_records.length) }})</nobr>
						</div>
						<ul v-if="square.subject_records.length==1">
							<li v-for="(f, k) in square.subject_records[0].frameworks" :key="f.fr.lsdoc_identifier">{{f.fr.json.CFDocument.title}}</li>
						</ul>
						<ul v-if="square.subject_records.length>1">
							<li v-for="(subject_record, j) in square.subject_records" :key="subject_record.subject.subject_guess_string.lsdoc_identifier" :class="subject_record.doc_showing?'':'k-frameworks-map-fw-link-not-showing'"><span :class="'k-framework-color-'+subject_record.subject.color_class+'-text'"><b>{{subject_record.subject.label}}</b></span></li>
						</ul>
					</div>
				</div>
			</div></k-hover></div>
		</div>
		<div v-if="open_mirrors_in_satchel" class="mt-6 pa-2 mx-auto text-left" style="font-size:14px; line-height:20px; max-width:720px; border-radius:8px; background-color:#ddd;">
			<div><span class="teal darken-4 white--text" style="border-radius:4px; padding:2px 6px;">Green agencies</span> have frameworks that have been published in CASE format by the agencies themselves.</div>
			<div class="mt-3" style="text-indent: -106px; margin-left:106px;"><span class="indigo darken-4 white--text" style="border-radius:4px; padding:2px 6px;">Blue agencies’</span> CASE frameworks are currently published and maintained by Common Good Learning Tools,<br>and are available only via Rosetta Exchange.</div>
		</div>
		<div v-if="expanded_square" class="k-frameworks-map-outer-scrim" @click="close_expanded_square"></div>
		<div v-if="expanded_square" class="k-frameworks-map-expanded-square-outer"><div class="k-frameworks-map-expanded-square elevation-3">
			<v-btn fab x-small color="amber accent-4" light class="elevation-1" style="position:absolute; right:2px; top:2px" aria-label="Close framework map details" @click="close_expanded_square"><v-icon small>fas fa-times</v-icon></v-btn>
			<div class="k-frameworks-map-square-menu-title">
				<div>{{expanded_square.category.title}}</div>
			</div>
			<div v-if="expanded_square.category && expanded_square.category.description" class="k-frameworks-map-square-menu-description" v-html="expanded_square.category.description"></div>
			<div class="k-frameworks-map-expanded-square-list">
				<div v-for="(subject_record, j) in expanded_square.subject_records" :key="subject_record.subject.subject_guess_string.lsdoc_identifier" :class="subject_record.doc_showing?'':'k-frameworks-map-fw-link-not-showing'">
					<div :class="'k-framework-color-'+subject_record.subject.color_class+'-text'" class="d-flex align-center"><div class="k-frameworks-map-menu-subject-bullet">•</div><div class="k-frameworks-map-menu-subject-title">{{subject_record.subject.label}}</div></div>
					<ul class="mt-1 mb-3">
						<li v-for="(f, k) in subject_record.frameworks" :key="f.fr.lsdoc_identifier" :class="expanded_square.category.doc_showing[f.fr.lsdoc_identifier]?'':'k-frameworks-map-fw-link-not-showing'">
							<a class="black--text" @click.stop="framework_clicked(f.fr,$event)">
								{{f.fr.json.CFDocument.title}}
								<span v-if="f.adoptionStatus!='Implemented'"><b>[{{f.adoptionStatus.toUpperCase()}}]</b></span>
							</a>
							<k-btn
								icon
								x-small
								:accessible-label="`Open ${f.fr.json.CFDocument.title}`"
								@click.stop="framework_clicked(f.fr,$event)"
							><v-icon style="margin-top:-2px; margin-left:4px" small :class="'k-framework-color-'+subject_record.subject.color_class+'-text'">fas fa-circle-arrow-right</v-icon></k-btn>
						</li>
					</ul>
				</div>

			</div>
		</div></div>
	</div>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
		category_records: { type: Array, required: true },
		// nreq: { type: String, required: false, default() { return ''} },
	},
	data() { return {
		max_map_row: 0,
		max_map_col: 0,
		square_dim: 0,
		hovered_square: null,
		hover_changed: false,
		mouse_pos_x: -1,
		mouse_pos_y: -1,
		category_menu_x: 0,
		category_menu_y: 0,
		expanded_square: null,
	}},
	computed: {
		...mapState(['site_config']),
		...mapGetters(['open_mirrors_in_satchel']),
		category_filter_value() { return vapp.framework_list_component.category_filter_value },
		squares() {
			function get_subject_records(category) {
				// TEMP: hide dots for some states
				// if (!category.self_publishing) return []
				// if (category.map_label == 'PR') return []
				// if (category.map_label == 'DC') return []

				let arr = []
				for (let fr of category.framework_records) {
					let subject = U.framework_subject_guess(fr.json.CFDocument)

					// TEMP: limit dots to certain subjects
					// if (!category.self_publishing && !(['Math', 'English'].includes(subject.subject_guess_string))) continue
					// if (!category.self_publishing && !(['Math', 'English', 'Social Studies', 'Science'].includes(subject.subject_guess_string))) continue

					let o = {
						fr: fr,
						adoptionStatus: CFDocument.adoption_status_display_value(fr.json.CFDocument.adoptionStatus)
					}
					let aso = CFDocument.adoption_statuses.find(x=>x.text == o.adoptionStatus)
					o.adoptionStatus_sort_order = (aso?.sort_order) || 10

					let sr = arr.find(x=>x.subject==subject)
					if (!sr) {
						arr.push({
							subject: subject,
							doc_showing: true,
							frameworks: [o],
						}) 
					} else {
						sr.frameworks.push(o)
					}
				}

				// sort subjects by subject.sort_index
				arr.sort((a,b)=>a.subject.sort_index - b.subject.sort_index)

				// then sort each subject's frameworks
				for (let s of arr) {
					s.frameworks.sort((a,b)=>{
						// sort first by adoption status
						if (a.adoptionStatus_sort_order != b.adoptionStatus_sort_order) {
							return a.adoptionStatus_sort_order - b.adoptionStatus_sort_order
						}

						// then by title
						if (a.fr.json.CFDocument.title.toLowerCase() < b.fr.json.CFDocument.title.toLowerCase()) return -1
						else if (a.fr.json.CFDocument.title.toLowerCase() > b.fr.json.CFDocument.title.toLowerCase()) return 1
						else return 0
					})
				}

				return arr
			}

			// translate map_data to older map_template format
			let msq = this.site_config.map_square_data.split('\n')
			let msmn = this.site_config.map_square_magic_numbers
			msq.shift()	// dispense of the initial row, which will be empty
			msq.pop()	// dispense of the last row, which will be empty
			let map_template = [], x = 0, y = 0
			for (let msr of msq) {
				x = 0
				let msra = msr.split('\t')
				for (let ml of msra) {
					if (!empty(ml)) {
						// add 'INT-' to the end of non-us codes
						// note that these magic numbers may need to be updated as the map evolves
						if (x <= msmn[0]) ml = `INT-${ml}`
						else if (x >= msmn[1]) ml = `INT-${ml}`
						else if (y <= msmn[2]) ml = `INT-${ml}`
						else if (y >= msmn[3]) ml = `INT-${ml}`
					}
					map_template.push({map_label: ml, x: x, y: y})
					++x
				}
				++y
			}
			// console.log(map_template)

			let rows = []
			this.max_map_row = 0
			this.max_map_col = 0
			for (let item of map_template) {
				if (!rows[item.y]) rows[item.y] = []

				let square = Object.assign({}, item)
				square.category = this.category_records.find(x=>x.map_label == square.map_label)

				rows[item.y][item.x] = square
				if (item.y > this.max_map_row) this.max_map_row = item.y
				if (item.x > this.max_map_col) this.max_map_col = item.x
			}

			// add blank cols
			for (let row of rows) {
				for (let i = 0; i <= this.max_map_col; ++i) {
					if (!row[i]) row[i] = {map_label: ''}
				}
			}

			// add extra categories in additional row(s) -- but these don't get filled in with the same number of columns
			let extra_row = []
			for (let cr of this.category_records) {
				if (cr.map_label && !map_template.find(x=>x.map_label == cr.map_label)) {
					if (extra_row.length == this.max_map_col) {
						rows.push(extra_row)
						extra_row = []
					}
					let square = {
						y: rows.length,
						x: extra_row.length,
						map_label: cr.map_label,
						category: cr,
					}
					extra_row.push(square)
				}
			}
			if (extra_row.length > 0) rows.push(extra_row)

			// when this is computed, if category_filter_value corresponds to one of the squares, show it
			if (!empty(this.category_filter_value)) {
				setTimeout(x=>{ this.square_clicked(null, this.category_filter_value) })
			}

			// fill in some values that all squares need
			for (let row of rows) {
				for (let square of row) {
					square.map_label_display = square.map_label.replace(/INT-/, ''),
					// this isn't currently needed, but not hurting anything and could be useful later
					square.map_label_for_element = square.map_label.replace(/:/g, '-colon-').replace(/ /g, '_')
					if (square.category) {
						square.subject_records = get_subject_records(square.category)
					}
				}
			}

			return rows
		},
		square_style() {
			return sr('flex: 0 0 $1; width:$1; height:$1; ', (this.square_dim + 'px'))
		},
		category_menu_style() {
			return sr('left:$1; top:$2', this.category_menu_x + 'px', this.category_menu_y + 'px')
		},
	},
	watch: {
		// on window size, resize squares
		'$vuetify.breakpoint.width': {immediate: true, handler(val) { this.set_square_dim() }},
		'$vuetify.breakpoint.height': {immediate: true, handler(val) { this.set_square_dim() }},
	},
	created() {
		vapp.frameworks_map_component = this
	},
	mounted() {
		// console.log(this.squares)
		// when we mount, if 
	},
	methods: {
		set_square_dim() {
			this.$nextTick(()=>{
				// let w = Math.floor($('.k-frameworks-map-outer').width() / (this.max_map_col + 1) - 8)
				// this.square_dim = w - 4
				// if (this.square_dim < 40) this.square_dim = 40

				let w = Math.floor($('.k-frameworks-map-outer').width() / (this.max_map_col + 1) - 8)
				let h = Math.floor(($(window).height() - 200) / 8 - 8)	// the US map has 8 rows; so use (8) instead of (this.squares.length)
				this.square_dim = ((w < h ? w : h) - 4)
				if (this.square_dim < 40) this.square_dim = 40
				if (this.square_dim > 64) this.square_dim = 64
				// console.log(w, h, this.square_dim)
			})
		},

		row_css(row_index) {
			let s = ''
			// "extra" frameworks outside the map get an extra class, and the first row gets an extra-extra class
			if (row_index > this.max_map_row) s += ' k-frameworks-map-row-extra'
			if (row_index == (this.max_map_row + 1)) s += ' k-frameworks-map-row-first-extra'
			return s
		},

		square_css(square, hover) {
			// console.log('square_css')
			// this fn gets called whenever the hover value changes for a square
			// so in addition to setting the square's css, we use this fn to set hovered_square based on hover
			if (!hover && square == this.hovered_square) this.hovered_square = null
			if (hover && this.hovered_square != square) {
				this.hovered_square = square
				// set hover_changed to true to temporarily hide the category menu until we can position it properly
				this.hover_changed = true
				setTimeout(x=>{
					this.hover_changed = false
					this.update_menu_pos()
				}, 100)
			}

			// if the square is blank, show it as a blank square
			if (!square || square.map_label == '') return 'k-frameworks-map-sq-blank'

			let s = 'k-frameworks-map-sq-inner'
			
			if (this.square_dim < 50) s += ' k-frameworks-map-sq-small'
			else if (this.square_dim < 60) s += ' k-frameworks-map-sq-med'
			else s += ' k-frameworks-map-sq-large'

			if (square.category) {
				if (square.category.self_publishing && this.open_mirrors_in_satchel) {
					s += ' k-frameworks-map-sq-filled-self-publishing'
				} else {
					// 'filled' class means the square is associated with a category that includes frameworks
					s += ' k-frameworks-map-sq-filled'

					// TEMP: for hilighting states that aren't yet self-publishing
					// s += ' k-frameworks-map-sq-hovered elevation-5'
				}
				// if search terms are entered and the square doesn't have any frameworks that match the terms, mark as "not showing"
				if (!square.category.showing) s += '-not-showing'

				// TEMP: add '-not-showing' class for some states
				// if (!square.category.self_publishing) s += '-not-showing'
				// if (square.map_label == 'PR') s += '-not-showing'
				// if (square.map_label == 'DC') s += '-not-showing'
			}

			if (hover && !this.expanded_square) s += ' k-frameworks-map-sq-hovered elevation-5'
			
			return s
		},

		square_label(square) {
			if (empty(square?.map_label)) return ''
			return square.map_label_display
		},

		// MC: not used???
		framework_dot_color(framework_record) {
			const framework_color = U.framework_color(framework_record.lsdoc_identifier)
			if (!isNaN(framework_color)) return 'k-framework-color-' + framework_color + '-text-light'
			return ''
		},

		mouse_moved(event) {
			this.mouse_pos_x = event.clientX
			this.mouse_pos_y = event.clientY
			this.update_menu_pos()
		},

		update_menu_pos(event) {
			if (this.hovered_square?.map_label) {
				let x = this.mouse_pos_x
				let y = this.mouse_pos_y
				// console.log(x,y)

				let offset_x = 16
				let offset_y = -12

				let menu = $(this.$el).find(`[data-map-label=${this.hovered_square.map_label_for_element}]`)
				let w = menu.outerWidth()
				let h = menu.outerHeight()

				// position the menu to the right of the cursor if it will fit there; otherwise position to the left
				if ((x + offset_x + w) < this.$vuetify.breakpoint.width) {
					x = x + offset_x
				} else {
					x = x - offset_x - w
				}

				// position the menu just above the cursor, unless we wouldn't be able to see the menu
				if ((y + offset_y + h) < this.$vuetify.breakpoint.height) {
					y = y + offset_y
				} else {
					y = y - offset_y - h
				}

				// console.log(w, h, x,y)

				this.category_menu_x = x
				this.category_menu_y = y
			}			
		},

		// this determines whether or not each square's hovered category menu is showing
		hovered_square_category_showing(square) {
			// if we're showing an expanded square, don't show
			if (this.expanded_square) return false
			// if a framework is showing, don't show
			if (vapp.framework_list_component.case_tree_lsdoc_identifier) return false
			// if the square is blank, nothing to show
			if (empty(square?.map_label)) return false
			// else if we're hovering over this square, show it
			if (this.hovered_square == square) return true
			// if we get to here, don't show it
			return false
		},

		square_clicked(event, square) {
			if (typeof(square) == 'string') {
				// if we get a string value for square, it's a category label; find it in the squares matrix
				let s
				for (let row of this.squares) {
					s = row.find(x=>x.category?.category == square)
					if (s) break
				}
				if (s) {
					square = s
				} else {	// this shouldn't happen
					console.warn('square_clicked called with string, but no square found', square)
					return
				}
			}

			if (!square.category) {
				// window.open('https://casenetwork.commongoodlt.com')
				return
			}

			// "expand" the square to show all frameworks for the agency
			this.expanded_square = square

			// if this square has a category, set category_filter_value in FrameworkList
			if (!empty(square.category)) {
				if (vapp.framework_list_component.category_filter_value != square.category.category) {
					vapp.framework_list_component.category_filter_value = square.category.category
				}
			}

			// scroll to make sure as much of the expanded square is showing as possible
			setTimeout(x=>this.$vuetify.goTo('.k-frameworks-map-expanded-square', {container: '.k-framework-list-wrapper-inner', duration:200, offset:-56}), 10)	// 
		},

		close_expanded_square() {
			vapp.framework_list_component.category_filter_value = null
			this.expanded_square = null
		},

		framework_clicked(fr, $event) {
			this.$emit('view_framework', [fr.lsdoc_identifier, null, $event])
		},

		write_map_template() {
			let s = ''
			for (let row of this.squares) {
				for (let i = 0; i < row.length; ++i) {
					if (row[i]?.map_label) s += row[i].map_label
					s += '\t'
				}
				s += '\n'
			}
			console.log(s)
		},
	}
}
</script>

<style lang="scss">
.k-frameworks-map-outer {
	width:100%;
	max-width:1000px;
	margin:20px auto 60px auto;
	position:relative;
}

.k-frameworks-map-outer-scrim {
	background-color:rgba(0,0,0,0.3);
	cursor:pointer;
	position:absolute;
	left:0;
	top:0;
	width:calc(100% + 40px);
	height:calc(100% + 8px);
	margin:-4px -20px -18px -20px;
	z-index:9;
	border-radius:12px;
}

.k-frameworks-map-instructions {
	position:absolute;
	left:340px;
	top:100px;
	background-color:$v-amber-lighten-4;
	padding:2px 8px;
	border-radius:4px;
}

.k-frameworks-map-row {
	display:flex;
	align-items: center;
	justify-content: center;
}

.k-frameworks-map-row-first-extra {
	margin-top:16px;
	padding-top:16px;
	border-top:1px solid #999;
}

.k-frameworks-map-sq {
	cursor: pointer;
	flex:0 0 auto;
	margin:4px;
}

.k-frameworks-map-sq-mid {
	width:100%;
	height:100%;
}

.k-frameworks-map-sq-inner {
	width:100%;
	height:100%;
	padding:4px;
	background-color:#ddd;
	color:#000;
	font-size:16px;
	border-radius: 5px;
	display:flex;
	flex-direction: column;
	border:2px solid transparent;
	transition: transform 0.1s;
}

.k-frameworks-map-sq-subs {
	text-align:left;
	line-height: 2px;
	margin-left:-2px;
}
.k-frameworks-map-sq-sub { 
	// font-size:48px; 
	// letter-spacing: -4px;
}

.k-frameworks-map-sq-small { font-size:10px; line-height:10px; padding: 2px; .k-frameworks-map-sq-subs { margin-bottom:-4px; } .k-frameworks-map-sq-sub { font-size:24px; letter-spacing:-1px; } }
.k-frameworks-map-sq-med { font-size:13px; line-height:13px; padding: 3px; .k-frameworks-map-sq-subs { margin-bottom:-6px; } .k-frameworks-map-sq-sub { font-size:36px; letter-spacing:-2px; } }
.k-frameworks-map-sq-large { font-size:16px; line-height:16px; padding: 4px; .k-frameworks-map-sq-subs { margin-bottom:-6px; } .k-frameworks-map-sq-sub { font-size:44px; letter-spacing:-4px; } }

.k-frameworks-map-sq-hovered {
	border-color: $v-amber-accent-4;
	transform:scale(1.2);
}

.k-frameworks-map-sq-blank {
	visibility:hidden;
}

.k-frameworks-map-sq-filled {
	background-color:$v-indigo-darken-4;
	color:#fff;
}

.k-frameworks-map-sq-filled-not-showing {
	background-color:$v-indigo-lighten-3;
	color:#000;
}

.k-frameworks-map-sq-filled-self-publishing {
	background-color:$v-teal-darken-4;
	color:#fff;
}

.k-frameworks-map-sq-filled-self-publishing-not-showing {
	background-color:$v-teal-lighten-3;
	color:#000;
}

.k-frameworks-map-square-menu {
	position:fixed;
	// margin:-12px 0 0 16px;
	border:2px solid $v-amber-accent-4;
	border-radius:12px;
	padding:12px;
	background-color:#eee;
	color:#000;
	font-size:14px;
	line-height:17px;
	min-width:300px;
	max-width:500px;
	max-height:calc(100vh - 8px);
	overflow:auto;
	// margin-left:-6px;
	// margin-top:-6px;
	z-index:10;
	li { margin-top:3px; margin-bottom:3px; }
	a:hover { text-decoration: underline; }
}

.k-frameworks-map-square-menu-no-category {
	background-color:#fff;
	border-color:transparent;
	color:#000;
	min-width: auto;
	// margin:0;
}

.k-frameworks-map-square-menu-title {
	font-size:18px;
	line-height:22px;
	font-weight:bold;
	margin-bottom:6px;
	display:flex;
	align-items: flex-start;
}

.k-frameworks-map-square-menu-description {
	font-size:14px;
	line-height:17px;
	background-color:#fff;
	border-radius:8px;
	padding:8px;
}

.k-frameworks-map-menu-subject-bullet {
	display:inline-block;
	font-size:48px;
	line-height:0;
	// margin-bottom:-12px;
}
.k-frameworks-map-menu-subject-title {
	font-size:16px;
	line-height:22px;
	font-weight:bold;
	margin-top:-2px;
	margin-left:4px;
}

.k-frameworks-map-expanded-square-outer {
	position:absolute;
	left:0;
	top:0;
	width:100%;
	height:100%;
}

.k-frameworks-map-expanded-square {
	position:relative;
	border:4px solid $v-amber-accent-4;
	border-radius:12px;
	padding:12px;
	background-color:#eee;
	color:#000;
	font-size:14px;
	line-height:19px;
	width:640px;
	margin:32px auto 8px auto;
	max-width:100vw;
	max-height:calc(100vh - 200px);
	overflow:auto;
	z-index:10;
}

.k-frameworks-map-expanded-square-list {
	margin-top:8px;
	// max-height:calc(100vh - 360px);
	// max-height:calc(100% - 28px);
	// overflow:auto;
	a:hover { text-decoration:underline; }
}


.k-frameworks-map-fw-link-not-showing {
	opacity:0.5;
}

// .k-frameworks-map-row-extra {
// 	.k-frameworks-map-sq-filled {
// 		background-color:$v-teal-darken-4;
// 	}
// 	.k-frameworks-map-sq-filled-not-showing {
// 		background-color:$v-teal-lighten-3;
// 	}
// 	.k-frameworks-map-square-menu {
// 		background-color:$v-teal-lighten-5;
// 	}
// }

</style>
